<template>
    <v-autocomplete :model-value="modelValue" :items="items" :loading="loading" item-title="name" item-value="id" :label="label" variant="outlined" :error-messages="errorMessages" :no-data-text="noDataText" @update:model-value="$emit('update:modelValue', $event)">
        <template #item="{ props: itemProps, item }">
            <v-list-item v-bind="itemProps">
                <template #subtitle> {{ item.raw.steward?.data?.steward_code ?? '' }} &middot; {{ item.raw.date ?? 'No date' }} </template>
            </v-list-item>
        </template>
    </v-autocomplete>
</template>

<script setup lang="ts">
import type { IPayoutEvent } from '@app/purchase/bundle/models/PayoutEvent.ts';

defineProps({
    modelValue: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    items: {
        type: Array as PropType<IPayoutEvent[]>,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    errorMessages: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        default: 'Select a draft payout event',
    },
    noDataText: {
        type: String,
        default: 'No eligible payout events found',
    },
});

defineEmits<{
    'update:modelValue': [value: string | null];
}>();
</script>
